
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/[[...deeplinkSlug]]",
      function () {
        return require("private-next-pages/app/[[...deeplinkSlug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/[[...deeplinkSlug]]"])
      });
    }
  